import { call, all } from "redux-saga/effects";
import { LoginActionWatcher } from "../containers/LoginContainer/saga";
import { SignupActionWatcher } from "../containers/SignupContainer/saga";
import { dashboardActionWatcher } from "../containers/DefaultLayout/saga";
import { userActionWatcher } from "../containers/UsersContainer/saga";
import { SupportCenteActionWatcher } from "../containers/SupportCenterContainer/saga";
import { PartnerRequestActionWatcher } from "../containers/PartnerRequestContainer/saga";
import { AddOutboxRequestActionWatcher } from "../containers/AddOutboxRequestContainer/saga";
import { VehicleActionWatcher } from "../containers/MyVehiclesContainer/saga";
import { AddNewDriverActionWatcher } from "../containers/AddNewDriverContainer/saga";
import { DriverActionWatcher } from "../containers/DriversContainer/saga";
import { MyPlanActionWatcher } from "../containers/MyPlansContainer/saga";
import { LoadDataActionWatcher } from "../containers/LoadBoardContainer/saga";
import { MySubscriptionActionWatcher } from "../containers/MySubscriptionContainer/saga";
import { tripDesignActionWatcher } from "../containers/TripDesignContainer/saga";
import { MyTeamsActionWatcher } from "../containers/MyTeamsContainer/saga";
import { MyDriversActionWatcher } from "../containers/MyDriversContainer/saga";
import { tripDesignCRUDActionWatcher } from "../containers/TripDesignCrudContainer/saga";
import { shipperActionWatcher } from "../containers/ShipperContainer/saga";
import { loadMetricsWatcher } from "../containers/LoadMetricsContainer/saga";
import { RateCardActionWatcher } from "../containers/RateCardContainer/saga";
import { TripEventsActionWatcher } from "../containers/TripEventsContainer/saga";
import { ProfileupdateActionWatcher } from "../containers/ProfileUpdateContainer/saga";
import { CompletedOrdersActionWatcher } from "../containers/CompletedOrderContainer/saga";
import { ShipperProfActionWatcher } from "../containers/MyProfileContainer/saga";
import { EditShipperProfActionWatcher } from "../containers/EditProfileContainer/saga";
import { expenseMapActionWatcher } from "../containers/ExpenseContainer/saga";
import { invoiceMapActionWatcher } from "../containers/InvoiceContainer/saga";
import { runnerinvoiceMapActionWatcher } from "../containers/RunnerInvoiceContainer/saga";
import { paymentsMapActionWatcher } from "../containers/PaymentContainer/saga";
import { OpertnLocationActionWatcher } from "../containers/RunnerOperatingLocContainer/saga";
import { RunnerSubsrptnActionWatcher } from "../containers/RunnerSubsptnContainer/saga";
import { notificationActionWatcher } from "../containers/NotificationContainer/saga";
import { resetPasswordActionWatcher } from "../containers/ResetPasswordContainer/saga";
import { forgotPasswordActionWatcher } from "../containers/ForgottPasswordContainer/saga";
import { WarehouseActionWatcher } from "../containers/WarehouseManagementContainer/saga";
import { WarehousePlanActionWatcher } from "../containers/WarehousePlanContainer/saga";
import { OthersSubtnWarehusActionWatcher } from "../containers/UserSbsrptnWarehouseContainer/saga";
import { MySubscriptionsWarehouseActionWatcher } from "../containers/MySubscriptionsWarehouseContainer/saga";
import { WarehouseSubscriptionsActionWatcher } from "../containers/WarehouseSubsrptnsContainer/saga";
import { UserPlanSbsrptnWarehseActionWatcher } from "../containers/UserPlanSbsrptnWarehseContainer/saga";
import { WarehsProviderSbsrptnActionWatcher } from "../containers/WarehsProviderSbsrptnContainer/saga";
import { WarehsPerformanceWatcher } from '../containers/WarehousePerformanceContainer/saga';
import { runnerpaymentMapActionWatcher } from '../containers/RunnerPaymentsContainer/saga';
import {InvoiceConfigActionWatcher} from '../containers/InvoiceConfigContainer/saga';
function* rootSaga() {
  yield all([
    call(LoginActionWatcher),
    call(SignupActionWatcher),
    call(dashboardActionWatcher),
    call(SupportCenteActionWatcher),
    call(userActionWatcher),
    call(PartnerRequestActionWatcher),
    call(AddOutboxRequestActionWatcher),
    call(VehicleActionWatcher),
    call(AddNewDriverActionWatcher),
    call(DriverActionWatcher),
    call(MyPlanActionWatcher),
    call(LoadDataActionWatcher),
    call(MySubscriptionActionWatcher),
    call(tripDesignActionWatcher),
    call(MyTeamsActionWatcher),
    call(tripDesignCRUDActionWatcher),
    call(MyDriversActionWatcher),
    call(shipperActionWatcher),
    call(loadMetricsWatcher),
    call(RateCardActionWatcher),
    call(TripEventsActionWatcher),
    call(ProfileupdateActionWatcher),
    call(CompletedOrdersActionWatcher),
    call(ShipperProfActionWatcher),
    call(EditShipperProfActionWatcher),
    call(expenseMapActionWatcher),
    call(invoiceMapActionWatcher),
    call(runnerinvoiceMapActionWatcher),
    call(paymentsMapActionWatcher),
    call(OpertnLocationActionWatcher),
    call(RunnerSubsrptnActionWatcher),
    call(notificationActionWatcher),
    call(resetPasswordActionWatcher),
    call(forgotPasswordActionWatcher),
    call(WarehouseActionWatcher),
    call(WarehousePlanActionWatcher),
    call(OthersSubtnWarehusActionWatcher),
    call(MySubscriptionsWarehouseActionWatcher),
    call(WarehouseSubscriptionsActionWatcher),
    call(UserPlanSbsrptnWarehseActionWatcher),
    call(WarehsProviderSbsrptnActionWatcher),
    call(WarehsPerformanceWatcher),
    call(runnerpaymentMapActionWatcher),
    call(InvoiceConfigActionWatcher)
  ]);
}

export default rootSaga;
